import React, { useReducer } from 'react'

const TYPES = {
  SET_CURRENT_PRODUCT: 'scanner/SET_CURRENT_PRODUCT',
}

const ScannerContext = React.createContext()

export const initialState = {
  currentProduct: null,
}

// This is equivalent to standard reducer's switch-case statement but more condensed, readable and separable
const handlers = {}

handlers[TYPES.SET_CURRENT_PRODUCT] = (state, action) => ({
  ...state,
  currentProduct: action.product,
})

// Reducer factory to enable enhanced syntax above
const reducerFactory = (initialState, handlers) => (state = initialState, action) =>
  handlers && handlers[action.type] ? handlers[action.type](state, action) : state

const reducer = reducerFactory(initialState, handlers)

// Provider component which will be used to wrap a group of components in order to pass context variables
const ScannerContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const value = { state, dispatch }

  return <ScannerContext.Provider value={value}>{props.children}</ScannerContext.Provider>
}

export { ScannerContext, ScannerContextProvider }
